// extracted by mini-css-extract-plugin
export default {"sectionClientsTable":"SalesModalContainer_sectionClientsTable__YG7EY","tableWrap":"SalesModalContainer_tableWrap__g753A"};